const FIELDS = Object.freeze([
  "title",
  "note",
  "activityType",
  "dateChoice",
  "customDate",
  "time",
  "entityType",
  "entityId",
]);

export const readActivityQuickAddNavigationState = ({
  baseline = {},
  current = {},
  open = false,
}) => {
  if (!open) return Object.freeze({ dirty: false, pending: false });
  const changed = FIELDS.filter(
    (field) => JSON.stringify(current[field]) !== JSON.stringify(baseline[field]),
  );
  return Object.freeze({
    dirty: changed.length > 0,
    pending: current.saving === true,
    revision: changed.length ? changed.join(",") : undefined,
  });
};
